const Referrals = () => (
    <svg
        width='35'
        height='35'
        viewBox='0 0 35 35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13.6473 20.5289L4.68539 25.0097C2.07209 25.1723 0 27.3461 0 29.9999C0 32.7596 2.24039 35 5.00009 35C7.75978 35 10.0002 32.7596 10.0002 29.9999C10.0002 28.418 9.26367 27.0065 8.11528 26.09L16.2501 22.0226V25.1579C14.0946 25.7135 12.5001 27.6719 12.5001 29.9999C12.5001 32.7596 14.7405 35 17.5002 35C20.2595 35 22.4999 32.7596 22.4999 29.9999C22.4999 27.6719 20.9057 25.7135 18.7499 25.1579V22.0226L26.885 26.09C25.7363 27.0065 25.0001 28.418 25.0001 29.9999C25.0001 32.7596 27.2405 35 29.9999 35C32.7596 35 35 32.7596 35 29.9999C35 27.3461 32.9279 25.1723 30.3146 25.0097L21.3527 20.5289C25.3148 18.9845 28.1249 15.1305 28.1249 10.6251C28.1249 4.76099 23.3642 0 17.5002 0C11.6361 0 6.87508 4.76099 6.87508 10.6251C6.87508 15.1305 9.68547 18.9845 13.6473 20.5289ZM23.7347 15.8328C24.958 14.3734 25.6274 12.5293 25.625 10.6251C25.625 6.14068 21.9842 2.50019 17.5002 2.50019C13.0158 2.50019 9.37497 6.14068 9.37497 10.6251C9.37261 12.5293 10.042 14.3734 11.2653 15.8328C12.6114 13.8237 14.9022 12.5001 17.5002 12.5001C20.0978 12.5001 22.3889 13.8237 23.7347 15.8328V15.8328ZM17.5002 3.74999C15.4305 3.74999 13.7502 5.43028 13.7502 7.49998C13.7502 9.56967 15.4305 11.25 17.5002 11.25C19.5698 11.25 21.2501 9.56967 21.2501 7.49998C21.2501 5.43028 19.5698 3.74999 17.5002 3.74999Z'
            fill='url(#paint0_linear_3860_3127)'
        />
        <defs>
            <linearGradient
                id='paint0_linear_3860_3127'
                x1='0'
                y1='17.5'
                x2='35'
                y2='17.5'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Referrals;
